import { devConfig } from './env.dev';
import { prodConfig } from './env.prod';

export interface EnvironmentConfig {
  name: string;
  baseUrl: string;
  apiUrl: string;
  /**
   * How the add-in reaches the LLM gateway in this environment:
   * - 'same-origin' → call `/api/ai/*`; a reverse proxy (webpack in dev, Traefik
   *   in prod) forwards to the gateway, so requests stay same-origin (no CORS).
   * - 'direct' → call the configured base URL cross-origin (gateway must send
   *   CORS headers for the add-in's origin).
   */
  aiProxy: 'same-origin' | 'direct';
}

export function getEnvironment(): EnvironmentConfig {
  if (process.env.NODE_ENV === 'production') {
    return prodConfig;
  }
  return devConfig;
}
